import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { color } from '../../../app/theme';
import icHelpCircle from '../../../assets/images/svg/ic-help-circle.svg';
import { setNodeData } from '../../../features/mainSlice';
import Switch from '../../shared/Switch';
import Tooltip from '../../shared/Tooltip';

const useStyles = makeStyles(
  () => ({
    root: {
      display: 'flex',
      alignItems: 'center',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 15,
      lineHeight: '15px',
      color: color.$3,
    },
  }),
  {
    name: 'SkipOOS',
  },
);

const SkipOOS = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { isActive } = useSelector(store => store.ma);
  const { selectedNode } = useSelector(state => state.ma);
  const { skipOOS } = selectedNode?.data;

  const onSwitch = e => {
    dispatch(
      setNodeData({
        skipOOS: e.target.checked,
      }),
    );
  };

  return (
    <div className={classes.root}>
      {t('messages.skipOOS-title')}
      <Tooltip light placement="top" title={t('messages.skipOOS-tooltip')}>
        <img src={icHelpCircle} alt="help" />
      </Tooltip>
      <Switch checked={skipOOS} onChange={onSwitch} disabled={isActive} />
    </div>
  );
};

export default SkipOOS;
